import { render, staticRenderFns } from "./Umsatzrentabilitaet.vue?vue&type=template&id=7af7d8e2&"
import script from "./Umsatzrentabilitaet.vue?vue&type=script&lang=ts&"
export * from "./Umsatzrentabilitaet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports